import { Button, Typography } from 'antd';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingRow, SpacingUnit } from 'components/ui';
import { useEditFormStore } from 'stores/local';

import s from './Header.module.scss';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const {
    editFormStore: { catalogDrawerControllerStore, formStore },
  } = useEditFormStore();

  const handleCustomFieldAdd = React.useCallback(() => {
    formStore.handleCustomFieldAdd();
  }, [formStore]);

  return (
    <div className={s.header}>
      <Typography.Title className={s.header__title} level={2}>
        {t('editForm.setupFields')}
      </Typography.Title>
      <SpacingRow hSpacing={SpacingUnit.unit2}>
        <Button onClick={handleCustomFieldAdd}>
          {t('editForm.createField')}
        </Button>
        <Button onClick={catalogDrawerControllerStore.open}>
          {t('editForm.addField')}
        </Button>
      </SpacingRow>
    </div>
  );
};

export default Header;
